import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FileSelectionOverlay from './FileSelectionOverlay';
import InputPasswordOverlay from './InputPasswordOverlay';
import { showOverlayActions } from '../../store/actions';
import PreviewEmailOverlay from './PreviewEmailOverlay';
import OCROverlay from './OCROverlay';
import UnassignNoteOverlay from './UnassignNoteOverlay';

interface OverlaysContainerProps {}

const showOverlaySelector = (state) => state.showOverlay;

const OverlaysContainer: React.FC<OverlaysContainerProps> = () => {
  const showOverlay = useSelector(showOverlaySelector);
  const dispatch = useDispatch();
  const handleClose = (overlayName: string) => {
    dispatch(showOverlayActions.close(overlayName));
  };
  return (
    <div>
      {[
        {
          OComponent: FileSelectionOverlay,
          name: 'FileSelection',
          title: 'File Selection',
        },
        {
          OComponent: InputPasswordOverlay,
          name: 'InputPassword',
          title: 'Password',
        },
        {
          OComponent: PreviewEmailOverlay,
          name: 'PreviewEmail',
          title: 'Preview Email',
        },
        {
          OComponent: OCROverlay,
          name: 'OCR',
          title: 'OCR Generated',
        },
        {
          OComponent: UnassignNoteOverlay,
          name: 'Note',
          title: 'Unassign',
        },
      ].map((o) => (
        <o.OComponent
          key={o.title}
          title={o.title}
          open={Boolean(showOverlay[o.name]) || false}
          handleClose={() => handleClose(o.name)}
        />
      ))}
    </div>
  );
};

export default OverlaysContainer;
